<template>
    <div>
      <!--Header Components-->
      <base-header class="pb-6" type="">
        <b-row class="align-items-center py-4">
          <b-col cols="8">
          </b-col>
          <b-col lg="8" cols="12">
            <!-- <h6 class="h2 text-white d-inline-block mb-0">{{$route.name}}</h6> -->
            <h6 class="h2 d-inline-block mb-0">{{ language_terms["CREDIT_NOTE"] }}</h6>
            <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
              <route-breadcrumb />
            </nav>
          </b-col>
        </b-row>
      </base-header>
      <!--Main Container Cards-->
      <b-container fluid class="mt--6 container-padding">
        <b-row>
            <div>
              <loading :active="loadingCounter > 0" 
                  color= '#007bff'
                  :width= '128'
                  :height= '128'
                  loader='dots'
                  :can-cancel="true" 
                  :is-full-page="true">
              </loading>
            </div>
          <b-col lg="12">
            <div class="card-wrapper">
              <card>
                <div slot="header" class="mb-0">
                  <b-row>
                    <b-col lg="12">
                      <div>
                        <span style="font-weight: bold">{{ document_title }} </span>
                        <span style="color: #ffc107;" v-if="form.status == 'PENDING_APPROVAL'"><i class="far fa-clock fa-lg" ></i></span>
                        <i class="fas fa-check-circle text-green fa-lg" v-if="form.is_approved == 1"></i>
                      </div>

                      <div>
                        <el-dropdown v-if="( $route.params.id != '_new') && (form.status != 'PENDING_APPROVAL') && !is_view_revision"  class="float-right mr-5">
                          <base-button icon type="warning">
                            {{language_terms['ACTIONS']}}<i class="el-icon-arrow-down el-icon--right"></i>
                          </base-button>
                          <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item  @click.native="convertToSO">{{language_terms['CONVERT_TO_SO']}}</el-dropdown-item>
                            <el-dropdown-item @click.native="convertToSI">{{language_terms['CONVERT_TO_SI']}}</el-dropdown-item>
                            <el-dropdown-item  @click.native="convertToSI">{{language_terms['CONVERT_TO_SI']}}</el-dropdown-item>
                            <el-dropdown-item @click.native="copyDocument">{{language_terms['COPY']}}</el-dropdown-item>
  
                          </el-dropdown-menu>
                        </el-dropdown>
                      </div>
                      <div>
                        <b-dropdown :text="language_terms['VIEW_REVISIONS']" class="float-right mr-5" v-if=" (document_mode != 'approval') && 0" variant="primary" >
                          <div v-for="(revision, index) in revisions" :key="index">
                            <b-dropdown-item v-if="revision.is_current == 0" @click="viewRevisionDoc(revision)">
                                <span v-if="revision.revision != 0">{{language_terms['REVISION']}} {{revision.revision}} - {{revision.time_created}}</span>
                                <span v-else>{{language_terms['ORIGINAL']}} - {{revision.time_created}}</span>
                              </b-dropdown-item>
                              <!-- {{revision.is_current}} -->
                              <b-dropdown-divider v-if="revision.is_current == 1" ></b-dropdown-divider>
                              <b-dropdown-item style="background-color:#c3e6cb" active v-if="revision.is_current == 1" @click="viewRevisionDoc(revision)">
                                {{language_terms['CURRENT']}} - {{revision.time_created}} 
                              </b-dropdown-item>
                          </div>
                        </b-dropdown>
                      </div>
                    </b-col>
                  </b-row>
                </div>
                <b-row>
                  <b-col :md="form.customer == '' ? 12 : 6">
                    <label class="form-control-label">{{language_terms['CUSTOMER']}}</label>
                      <multiselect
                        :internalSearch = "false"
                        v-model="form.customer"
                        id="ajax"
                        label="name"
                        track-by="id"
                        placeholder="Type to search"
                        open-direction="bottom"
                        :options="customers"
                        :multiple="false"
                        :searchable="true"
                        :clear-on-select="false"
                        :close-on-select="true"
                        :options-limit="300"
                        :limit="50"
                        :limit-text="limitText"
                        :max-height="600"
                        :show-no-results="false"
                        :hide-selected="false"
                        @search-change="asyncFindCustomer"
                        @input="onSelectCustomer"
                      >
                      </multiselect>
                  </b-col>
                  <b-col :md="business_units.length > 1 ? 4 : 6">
                    <label class="form-control-label">{{language_terms["INVOICE_NO"]}}</label>
                      <multiselect
                        :custom-label="invoiceNameWithCode"
                        v-model="form.document"
                        label="name"
                        placeholder="Type to search"
                        open-direction="bottom"
                        :options="invoices"
                        :multiple="false"
                        :searchable="true"
                        :loading="loading"
                        :clear-on-select="false"
                        :close-on-select="true"
                        :options-limit="300"
                        :limit="50"
                        :max-height="600"
                        :show-no-results="false"
                        :hide-selected="true"
                        @search-change="asyncFindInvoices"
                        @select="onSelectInvoice"
                      >
                      </multiselect>
                  </b-col> 
                </b-row>
                <b-row class="mt-4">
                  <b-col md="4">
                    <base-input
                      :label="language_terms['REFERENCE']"
                      :placeholder="language_terms['REFERENCE']"
                      v-model="form.reference"
                    ></base-input>
                  </b-col>
                  
                  <b-col md="4">
                    <base-input :label="language_terms['DATE']">
                      <flat-picker
                        slot-scope="{ focus, blur }"
                        @on-open="focus"
                        @on-close="blur"
                        style="background-color: white"
                        class="form-control datepicker"
                        v-model="form.date">
                      </flat-picker>
                    </base-input>
                  </b-col>
                  
                  <b-col md="4">
                    <base-input :label="language_terms['CURRENCY']">
                      <el-select
                        v-model="form.currency_code"
                        filterable
                        :placeholder="language_terms['CURRENCY']">
                        <el-option
                          v-for="option in currencies"
                          :key="option.id"
                          :label="option.code + ' (' + option.prefix + ')'"
                          :value="option.code">
                        </el-option>
                      </el-select>
                    </base-input>
                  </b-col>
                  
                </b-row>
                <b-row>
                  <b-col md="6">
                    <base-input label="Remarks (Customer to See)">
                      <textarea
                        class="form-control"
                        id="exampleFormControlTextarea1"
                        rows="3"
                        v-model="form.remarks">
                      </textarea>
                    </base-input>
                  </b-col>
                  <b-col md="6">
                    <!-- <base-input :label="language_terms['INTERNAL_REMARKS']"> -->
                    <base-input label="Remarks (Within Company)">
                      <textarea
                        class="form-control"
                        id="exampleFormControlTextarea1"
                        rows="3"
                        v-model="form.remarks_internal"
                      ></textarea>
                    </base-input>
                  </b-col>
                </b-row>
              </card>
            </div>
          </b-col>
        </b-row>
        <b-row v-if="form.contact_id != null && form.document.id != null">
          <b-col cols="12">
            <div class="card-wrapper">
              <card>
                <div slot="header" class="mb-0">
                  <b-row>
                    <b-col cols="8">
                        <h3>{{language_terms["CREDIT_NOTE_ITEMS"] }}</h3>
                    </b-col>
                  </b-row>
                </div>
                

                <!-- ITEMS START -->
                <b-row  v-if="is_editing">
                  <b-col sm="12">
                        <b-table-simple striped hover responsive>
                            <b-thead head-variant="light">
                              <tr>  
                                  <th>{{language_terms['SNO']}}</th>
                                  <th>{{language_terms['PRODUCT_CODE']}}</th>
                                  <th>{{language_terms['PRODUCT']}}</th>
                                  <th>{{language_terms['QTY']}}</th>
                                  <th>{{language_terms['UOM']}}</th>
                                  <th>{{language_terms['UNIT_PRICE']}}</th>
                                  <th>CN Qty</th>
                              </tr>
                            </b-thead>
                            <b-tbody>
                                <b-tr v-for="(row, index) in form.items" :key="index">
                                  <td width="20px">{{ row.sno }}</td>
                                  <td>{{row.product_code}}</td>
                                  <td>{{(row.product_name == null || row.product_name == "") ? row.product_name_master : row.product_name}}</td>
                                  <td>{{row.qty}}</td>
                                  <td>{{row.uom}}</td>
                                  <td>{{row.unit_price}}</td>
                                  <td>
                                    <base-input 
                                    type="number"
                                    v-on:change="calcDocumentTotal()"
                                    placeholder="0" :min="0" :max="row.qty"
                                    v-model="row.cn_qty"></base-input>                                    
                                  </td>
                                </b-tr>
                            </b-tbody>
                        </b-table-simple>
                    </b-col>
                </b-row>
                <b-row v-else>
                    <b-col sm="12">
                        <b-table-simple striped hover responsive>
                            <b-thead head-variant="light">
                              <tr>  
                                  <th>{{language_terms['SNO']}}</th>
                                  <th>{{language_terms['PRODUCT_CODE']}}</th>
                                  <th>{{language_terms['PRODUCT']}}</th>
                                  <th>{{language_terms['QTY']}}</th>
                                  <th>{{language_terms['UOM']}}</th>
                                  <th>{{language_terms['LIST_PRICE']}}</th>
                                  <th>{{language_terms['UNIT_PRICE']}}</th>
                                  <th>{{language_terms['AMOUNT']}}</th>
                                  <!-- <th>{{language_terms['TAX_AMOUNT']}}</th> -->
                                  <!-- <th>{{language_terms['NETT_AMOUNT']}}</th> -->
                              </tr>
                            </b-thead>
                            <b-tbody>
                                <b-tr v-for="(row, index) in form.items" :key="index">
                                  <td width="20px">{{ row.sno }}</td>
                                  <td>{{row.product_code}}</td>
                                  <td>{{(row.product_name == null || row.product_name == "") ? row.product_name_master : row.product_name}}</td>
                                  <td>{{row.qty}}</td>
                                  <td>{{row.uom}}</td>
                                  <td>{{row.sale_list_price ? row.sale_list_price : '-'}}</td>
                                  <td>{{row.unit_price}}</td>
                                  <td>{{row.gross_amount}}</td>
                                  <!-- <td>{{row.tax_amount}}</td> -->
                                  <!-- <td>{{row.nett_amount}}</td> -->
                                </b-tr>
                            </b-tbody>
                        </b-table-simple>
                    </b-col>
                </b-row>
                <!-- ITEMS END -->
                

                <b-row v-if="!is_editing">
                  <b-col lg="9"></b-col>
                  <b-col md="3">
                    <b-row class="form-group">
                      <label class="col-md-5 col-form-label form-control-label">{{language_terms['SUB_TOTAL']}}</label>
                      <b-col md="7">
                        <base-input v-model="form.gross_amount" disabled></base-input>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row v-else>
                  <b-col lg="9"></b-col>
                  <b-col md="3">
                    <b-row class="form-group">
                      <label class="col-md-5 col-form-label form-control-label">{{language_terms['SUB_TOTAL']}}</label>
                      <b-col md="7">
                        <base-input :value="(gross_amount *1).toFixed(2)" v-model="form.gross_amount" disabled></base-input>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row  style="margin-top:-38px" v-if="!is_editing"> 
                  <b-col lg="9"></b-col>
                  <b-col md="3">
                    <b-row class="form-group">
                      <label class="col-md-5 col-form-label form-control-label">{{language_terms['TAX_AMOUNT']}} 
                        <span>({{this.form.tax_rate_percent}}%)</span>
                      </label>
                      <b-col md="7">
                        <base-input v-model="form.tax_amount" disabled></base-input>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row  style="margin-top:-38px" v-else> 
                  <b-col lg="9"></b-col>
                  <b-col md="3">
                    <b-row class="form-group">
                      <label class="col-md-5 col-form-label form-control-label">{{language_terms['TAX_AMOUNT']}} 
                        <span>({{this.form.tax_rate_percent}}%)</span>
                      </label>
                      <b-col md="7">
                        <base-input :value="(tax_amount *1).toFixed(2)" v-model="form.tax_amount" disabled></base-input>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row  style="margin-top:-38px" v-if="!is_editing">
                  <b-col lg="9"></b-col>
                  <b-col md="3">
                    <b-row class="form-group">
                      <label class="col-md-5 col-form-label form-control-label">{{language_terms['GRAND_TOTAL']}}</label>
                      <b-col md="7">
                        <base-input v-model="form.nett_amount" disabled></base-input>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row  style="margin-top:-38px" v-else>
                  <b-col lg="9"></b-col>
                  <b-col md="3">
                    <b-row class="form-group">
                      <label class="col-md-5 col-form-label form-control-label">{{language_terms['GRAND_TOTAL']}}</label>
                      <b-col md="7">
                        <base-input :value="(nett_amount * 1).toFixed(2)" v-model="form.nett_amount" disabled></base-input>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row class="mt-3">
                    <b-col lg="12">
                        <base-button type="success" @click.native="saveDocument" class="mr-4">
                            {{language_terms['SAVE']}}
                        </base-button>
                        <base-button type="primary" @click.native="clickOnBack">
                            {{language_terms['BACK']}}
                        </base-button>
                    </b-col>
                </b-row>
                <!-- Summary End -->
              </card>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </template>
  <!--Must put this code to use auto complete component-->
  <style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
  
  <script>
  import { Select, Option,Table, TableColumn, Dropdown, DropdownMenu, DropdownItem } from "element-ui";
  import flatPicker from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";
  import axios from "axios";
  import { apiRoutes } from "../../apiRoutes";
  import { authHeader } from "../../global";
  import { mapState } from "vuex";
  import productLookup from "@/components/Autocomplete.vue";
  import tradeItemDespLookup from "@/components/Autocomplete.vue";
  import moment from "moment";
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';
  import Vue from 'vue';
  const item_is_collasped = false;
  
  export default {
    data() {
      return {
        invoices:[],
        is_editing: false,
        headerBgVariant: "primary",
        selected_invoice:{},
        popUpModalShow: false,
        priceHistoryColumns:['Inventory', 'S/No', 'Product Code', 'Qty', 'Unit Price', 'Credit Notes Qty', 'Credit Notes Amount'],
        priceCreditNoteColumns:['Inventory', 'S/No', 'Product Code', 'Qty', 'Unit Price', 'Credit Notes Qty'],
        priceHistoryOptions:{perPage:5, perPageValues:[],stickyHeader:false, stickyHeaderColor:'#ffffff', stickyHeaderBackground:'#292F4C',hiddenColumns:['id'],filterable:false},
        priceHistoryHeaders:['date'],
        sales_items_history_modal:false,
        sales_items_history_filter:{
          contact_id:"",
          type:""
        },    
        currentPage:1,
        filter:{
            keyword:"",
            date_from:'',
            date_to:''
        },
        filterOn: [],
        document_mode:null,
        printouts_modal:false,
        revison_modal:false,
        milestones_modal:false,
        loading:false,
        value: "",
        document_title: "",
        add_bom_index:-1,
        customers: [],
        documents:[],
        products:[],
        loadingCounter: 0,
        apiProductLookup: apiRoutes["PRODUCT_LOOKUP"],
        selected_customer:null,
        desp_tags:[],
        is_view_revision:0,
        nett_amount:"",
        tax_amount:"",
        gross_amount:"",
        form: {
          tax_amount:0,
          nett_amount:0,
          gross_amount:0,
          discount_amount:"",
          discount_value:"",
          subtype:"NORMAL_SALE",
          due_days_placeholder:"",
          revision_json:{},
          revision_id:null,
          time_printed:null,
          delivery_eta_date:null,
          action_edit:0,
          action_approval:0,
          require_approval:0,
          salesperson_contact_id:null,
          businessunit_contact_id:null,
          customer_credit_term:null,
          customer_credit_limit:null,
          customer_credit_limit_available:null,
          is_locked: false,
          is_approved: null,
          due_days: null,
          due_date: null,
          tax_code: "",
          tax_rate_percent: null,
          contact_id: null,
          customer: {},
          currency_code: "SGD",
          remarks:"",
          remarks_internal:"",
          items: [],
          type: null,
          items:[],
          document: [],
        },
      };
    },
    components: {
        [Select.name]: Select,
        [Option.name]: Option,
        [Dropdown.name]: Dropdown,
        [DropdownMenu.name]: DropdownMenu,
        [DropdownItem.name]: DropdownItem,
        flatPicker,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        productLookup,
        tradeItemDespLookup,
        // printDocument,
        Loading
    },
    computed: {
      ...mapState({
          document_total: state => state.sales.document_total,
          revisions: state => state.documentRevisions.revisions, 
          revision_is_created: state => state.documentRevisions.revision_created,
          revision_is_retrieved: state => state.documentRevisions.is_retrieved,
          revision_data: state => state.documentRevisions.data,
          is_approved: state => state.sales.is_approved,
          is_rejected: state => state.sales.is_rejected,
          // tradeitem_desp_list: state => state.products.tradeitem_desp_list,
          auth_user:state => state.auth.auth_user,
          printouts: state => state.documentPrintouts.printouts,
          milestones: state => state.documentMilestones.milestones,
          sales_filter:state => state.sales.filter,
          sale_is_created: (state) => state.sales.is_created,
          sale_is_updated: (state) => state.sales.is_updated,
          business_units: (state) => state.customers.business_units,
          currencies: (state) => state.currencies.currencies,
          taxes: (state) => state.taxes.taxes,
          taxData: (state) => state.taxes.data,
          product_price: (state) => state.products.product_price,
          sale_doc: (state) => state.sales.document,
          language_terms: (state) => state.languages.language_terms,
          selected_lang: (state) => state.languages.selected_langauge,
          uom_list:state => state.products.uom_list, 
          
      })
    },
    async mounted() 
    {
      this.loadingCounter++
      let documnet_id = this.$route.params.id;
  
      await this.$store.dispatch("sales/getDefaultSqValidityDays", {});
      await this.$store.dispatch("sales/getSalesSubTypes", {})

      if (documnet_id == "_new") 
      {
        this.setDefaults()
        this.is_editing = true
      } 
      else
      {      
        this.document_mode = this.$route.query.mode;
        if (this.type && documnet_id) 
        {
          await this.retrieveDocument(documnet_id, this.type);
        }
        this.document_title = `${this.$props.title} (${documnet_id})`;
  
        await this.asyncFindCustomer(this.sale_doc.contact_code);
  
        let selected_customer = {
          id: this.form.contact_id,
          code: this.form.contact_code,
          name: this.form.contact_name,
          customer_tax_code: this.form.contact_customer_tax_code,
        };
  
        this.form.customer = selected_customer;
  
        if(this.form.is_approved == 1) 
        {
          this.form.is_locked = true;
        }
  
        let vm = this
        this.form.items.forEach(function (element, index) {
              element.product = {id: element.product_id, name: element.product_name_master, code:element.product_code}
              element.trade_item = {product_name: element.product_name, contact_id:null, date:null}
              if(element.is_trade == 1)
              {
                  vm.addTag(element.product_name, index)
              }
        });
      }
  
      // await this.fetchCurrencies();
      // await this.fetchTaxes();
      // await this.fetchSalesPersons()
      await this.getAuthUser()
  
      if(this.auth_user)
      {
        if(!this.form.salesperson_contact_id)
          this.form.salesperson_contact_id = this.auth_user.contact_id
      }
      this.loadingCounter--
    },
    watch:{
          language_terms: {
              handler(val){
                  this.updateBomFiledTerms()
                  this.updateTableLang()
              },
              deep: true
          }
    },
    methods: 
    {
      async setDefaults()
      {
        this.document_title = "New " //+ this.$props.title;
        if(!this.form.date)
        {
          this.form.date = moment().format("YYYY-MM-DD");
        }
  
        if(!this.form.delivery_eta_date)
        {
          this.form.delivery_eta_date = moment().format("YYYY-MM-DD");
        }
  
        this.form.due_days_placeholder = this.default_sq_validity_days
  
        if(this.form.due_days)
          this.form.due_date = moment(this.form.date).add(this.form.due_days, "days").format("YYYY-MM-DD");
  
        if(this.form.date && this.form.tax_code)
        {
          this.retrieveRate(this.form.tax_code, this.form.date)
          this.form.tax_rate_percent = this.taxData.rate_percent
        }
      },
      updateTableLang()
      {
        for(let i=0; i < this.tableColumns.length;i++)
        {
            let key = this.tableColumns[i].key
            this.tableColumns[i].label = this.language_terms[key]
        }

        for(let i=0; i < this.itemFields.length;i++)
        {
            let key = this.itemFields[i].key
            this.itemFields[i].label = this.language_terms[key]
        }
    },
      invoiceNameWithCode ({ code }) 
        {
            if(code)
                return `${code}`
        },
      async clickOnSearch()
        {
      
      await this.$store.dispatch("stockcards/quickSearchInventory", this.filter);
        },
      onFiltered(filteredItems) {
        this.currentPage = 1
      },
      cancelItemsHistoryModal()
      {
        this.sales_items_history_modal = false
      },
      async calcDocumentTotal()
      {
        let document_total = null
        let payload = this.form
        await axios.post(apiRoutes['CREDITNOTE_CALC_TOTAL'], payload, authHeader())
        .then(response => {
          if (response.data.code == 1) 
          {
            document_total = response.data.data
          } 
          else 
          {
            this.document.items = []
          }
        })
        .catch(error => {
          if (error.response) 
            Vue.notify({group: 'notify', type: 'error', text: error.response.data.msg, max: 5, duration: 5000, speed: 300})
        });
          
        if(this.document_total)
        {
          this.form.gross_amount = document_total.sub_total.toFixed(2)
          this.form.nett_amount = document_total.nett_amount.toFixed(2)
          this.form.tax_amount = document_total.tax_amount.toFixed(2)
          //console.log('form gross amount', this.form.gross_amount);
          //console.log('nett amount', this.form.nett_amount);
          //console.log('taxamount', this.form.tax_amount);
        }
      },
      async copyDocument()
      {
        this.loadingCounter ++
  
        this.form.document_id = this.form.id
        await this.$store.dispatch("sales/copy", this.form);
        if(this.is_copied)
        {
          this.$router.push("/sales/sales-order/" + this.copied_code)
  
        }
  
        this.loadingCounter--
      },
      startsWith(str, word) {
          return str.lastIndexOf(word, 0) === 0;
      },
      isFoundInList(name)
      {
          let is_found = 0
          for(let i = 0; i < this.desp_tags.length; i++)
          {
              if(this.desp_tags[i].product_name == name)
              {
                is_found = 1
              }
          }
          return is_found;
      },
      async getAuthUser()
      {
        await this.$store.dispatch("auth/getAuthUser", {})
      },
      async searchSales()
      {
          this.loadingCounter++
          let filter = {
                          keyword:"",
                          date_from:null,
                          date_to:null,
                          type:this.form.type,
                          status:'ALL'
                        }
          if(this.sales_filter)
          {
              filter = this.sales_filter
          }
          await this.$store.dispatch('sales/quickSearch', filter)
  
          this.loadingCounter--
      },
      productNameWithCode ({ name, code }) {
        if(name || code)
          return `${name} :: ${code}`
      },
      customerNameWithCode ({ name, code }) {
        if(name || code)
          return `${name} (${code})`
      },
      async approveDocument()
      {
          await this.$store.dispatch("sales/approveDocument", {document_id:this.form.id})
  
          if(this.is_approved)
          {
            await this.searchSales();
            this.routeToMaster()
          } 
      },
      async rejectDocument()
      {
          this.$store.dispatch("sales/rejectDocument", {document_id:this.form.id})
          if(this.is_rejected)
          {
             await this.searchSales();
             this.routeToMaster()
          } 
      },
      editDocument()
      {
        //this.is_edit = true
      },
      async retrieveRate(code, date) 
      {
        await this.$store.dispatch("taxes/fetch", { code: code, date: date });
        this.form.tax_rate_percent = this.taxData.rate_percent;
      },
      onSelectInvoice(obj)
        {
            if(obj.code)
            {
              this.retrieveInvoiceItems(obj.code)
            }
        },
      async retrieveInvoiceItems(code)
      {
        this.loadingCounter++

        if (code)
        {
          let payload = {code:code}
          axios.post(apiRoutes['RETRIEVE_INVOICE'], payload, authHeader())
          .then(response => {
            if (response.data.code == 1) 
            {
              this.form.items = response.data.data.items
            } 
            else 
            {
              this.document.items = []
            }
          })
          .catch(error => {
            if (error.response) 
              Vue.notify({group: 'notify', type: 'error', text: error.response.data.msg, max: 5, duration: 5000, speed: 300})
          });
        }

        this.loadingCounter --
      },
      async onSelectCustomer(selectedOption) {
        if (selectedOption) 
        {
          if(selectedOption.id)
          {
            this.form.document_id = null
            this.form.contact_id = selectedOption.id;
            this.form.tax_code = selectedOption.customer_tax_code;
            this.form.currency_code = selectedOption.currency_code;
            this.form.customer_credit_term = selectedOption.customer_credit_term;
            this.form.customer_credit_limit = selectedOption.customer_credit_limit;
            this.form.customer_credit_limit_available = selectedOption.customer_credit_limit_available;
            this.form.attention_to = selectedOption.contact_person

            this.form.document = []
            this.form.items = []
            this.form.gross_amount = 0
            this.form.tax_amount = 0
            this.form.nett_amount = 0
            
            await this.retrieveRate(this.form.tax_code, this.form.date)
            this.form.tax_rate_percent = this.taxData.rate_percent
          }
        }
      },
      limitText(count) {
        return `and ${count} other countries`;
      },
      clickOnBack()
        {
            this.$router.push("/finance/credit-notes")
        },
      async saveDocument() 
      {
        if (this.$route.params.id == "_new") 
        {
          this.form.type = this.type;
          await this.$store.dispatch("sales/create", this.form);
  
          if(this.sale_is_created)
          {
            await this.searchSales();
            this.routeToMaster();
          }
        } 
        else 
        {
          this.form.type = this.type;
          
          if(this.form.time_printed || this.form.revision != 0 || this.form.is_approved != null)
          {
            //alert('x')
            await this.$store.dispatch("documentRevisions/create", this.form);
  
              if(this.revision_is_created == "1")
              {
                  await this.searchSales();
                  this.routeToMaster();
              }
  
          }
          else
          {
  
              await this.$store.dispatch("sales/update", this.form);
  
              if(this.sale_is_updated == "1")
              {
                  await this.searchSales();
                  this.routeToMaster();
              }
          }
  
        }
      },
      routeToMaster() 
      {
          this.$router.push("/finance/credit-note");
      },
      cancelDocument() 
      {
  
        if(this.$route.params.id == '_new')
        {
          this.routeToMaster()
        }
        else
        {
          location.reload();
        }
        
      },
      async asyncFindInvoices() 
      {
        // Invoice LookUp
        this.loadingCounter++

        let pv = {"contact_id": {"operator":"=", "value": this.form.customer.id}}
        await axios
        .post(apiRoutes["FILTER_INVOICES"], pv, authHeader())
        .then((response) => {
        if (response.data.code == 1) {  
            this.invoices = response.data.data;
        } 
        else 
        {
            this.invoices = [];
        }
        })
        .catch((error) => {
        if (error.response) 
        {
          Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
        } 
      });
      this.loadingCounter--
    },
    async asyncFindCustomer(query) 
    {
      let pv = { value: query };
      await axios.post(apiRoutes["CUSTOMER_LOOKUP"], pv, authHeader()).then((response) => {
          if (response.data.code == 1) {
            this.customers = response.data.data;
          } else {
            this.customers = [];
          }

          this.loadingCounter--;
        })
        .catch((error) => {
          if (error.response) {
            Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
          }
        });
    },
    },
  };
  </script>
  <style>
    th.VueTables__sortable {
        color:rgb(255,255,255);
    }
    td.VueTables__row  {
        color:black
    }
    .v-data-table /deep/ .sticky-header {
      position: sticky;
      top: var(--toolbarHeight);
    }
    
    .v-data-table /deep/ .v-data-table__wrapper {
      overflow: unset;
    }
  </style>
  <style scoped>
  .marginCheck{
    margin-right:90px;
  }
   .float-button2
    {
  
      position:fixed;
      width:60px;
      height:60px;
      bottom:40px;
      /* background-color:#0C9; */
      background-color:#2dce89;
      color:#FFF;
      border-radius:50px;
      text-align:center;
      box-shadow: 2px 2px 3px #999;
    }
  /* .marginPlus{
    margin-right:220px;
  } */
  </style>